import React, { Component } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu,Segment, Sidebar } from "semantic-ui-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FadeLoader } from "react-spinners";
import swal from "sweetalert";
import CheckBoxSnow from "./CheckBoxSnow";

import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import calendar from "../assets/calendar.ico";
//import FloatingBulletin from './FloatingBulletin'; 

import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import pagecontent from "../Helpers/SnowContent";
import AboutModal from "../../GeoportalModal";
import TreeNode from "./TreeNodeV3";
import MapView from "./MapViewV3";
import colors from "../../colors";

import { Rnd } from "react-rnd";
import Chart from "./CChart";
import ReactHTMLParser from "react-html-parser";
import menus from "../Helpers/menus";
import file_ext from "../Helpers/file-tails";
import domain from "../../domain";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
//import * as turf from '@turf/turf';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  faAngleDown,
  faStopCircle,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";

import {
  fetchHRivers,
  fetchHRiverBoundary,
  fetchHBasins,
  fetchRiverBasinStats,
  fetchRiverStats,
  fetchRiverStatsDefault,
  fetchHRiverBasinBoundary,
  fetchRiverBasinStatsByDates,
  fetchRiverStatsByDates,
  fetchSnowFractionDatesStartEnd,

} from "../../apicalls";
import { latLng } from "leaflet";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);

library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);

var moment = require("moment");

function change_date(d) {
 ////console.log(d);
  var today = new Date(d);
  var dd = today.getDate();

  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
 // console.log(yyyy);
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "-" + mm + "-" + yyyy;
  return today;
}

function findMinMax(arr) {
 // console.log(arr[0][1]);
  let min = arr[0][1],
    max = arr[0][1];
  let minindex = 0,
    maxindex = 0;
  for (let i = 1, len = arr.length; i < len; i++) {
    let v = arr[i][1];
   // console.log(v, i);
    minindex = v < min ? i : minindex;
    maxindex = v >= max ? i : maxindex;
    min = v < min ? v : min;
    max = v >= max ? v : max;
  }
  return maxindex;
}


class MapContainer extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      baseLayers: false,


      comparisonOverlays: [], // State variable to store comparison overlays
      arraycheck: [], // State variable to store checked overlays
      
      workspace:"#",
      layerleft:"#",
      layerright:"#",
      india_states_boundary: null,
      snowproductselected:"#",
      snowproductselectedR:"#",

      modal: true,
      layerExist: true,
      tabs: menus.mapSideBar,
      
      collapsed:true,
      collapsed1:false,
      collapsed2:false, //scf
      collapsed3:false,
      collapsed4:false,
      titleTimeseries:"#",

      clickcount: 0,
      isDraggingAllowed:true,
      timestampselected:"#",
      basinselected:"#",
      
      boundary:null,
     
      selectedMonthStart: '',
      selectedMonthEnd: '',
      selectedStrtMon:'#',
      selectedStrtYear:'#',
      selectedEndMon:'#',
      selectedEndYear:'#',
     

      buttonColor :"white",
      visibleGraphPanel1:false,
      
      compareLeftDate:null,
      compareleftDateForLayer:null,
      compareLeftWorkspace:null,
      compareLeftLayer:null,     
      visualizeLeftCompareFile:false,
      compareButtonColor:"white",
     

      compareRightDate:null,
      compareRightDateForLayer:null,
      compareRightWorkspace:null,
      compareRightLayer:null,
      visualizeRightCompareFile:false,
      compareButtonColorR:"white",
      

      tableenable: false,
      inlinemode:false,
      graphenable: false,
      // width: 420,
      // height: 400,
      // x: (window.innerWidth-270-800)/2,
      // y: window.innerHeight - 460,
      x: Math.max((window.innerWidth - 1200) / 2, 10), // Center but prevent negative x
      y: Math.max(window.innerHeight - 650, 10),
      width: Math.min(800, window.innerWidth * 0.9), // Adjust width for small screens
      height:Math.min(400, window.innerHeight * 0.9),
      
      tabs: menus.mapSideBar,
      visibleTableData: false,
      visibleGraphPanel_pie: false,
      latlng: { lat: null, lng: null },
      legendVisible: true,
      activeIndex: 0,
      daily_stats: null,
      daily_stat: true,
      time_stat: false,
      selectedMenu: null,
      subabsindata: null,
      chartloading: false,
      shown: false,
      month: null,
      basins: "",
      modal:true,
      pointInfo: null,
      forecastpixelValue:null,
      legend: null,
      selectedLayer: {},
      visible: window.innerWidth > 1000 ? true : false,

      date: "",
      layerExist: true,
      wms_url_default: `${domain.Geoserver}/nhp_daily-snow-cover/wms`,

      visibleGraphPanel: false,
      availableDates: [],
      selectedNodeStaus: {},
      slideTracker: -1,
     
      onClickDetails: {},
      stateInfo: null,
      dateEnabled: false,
      sliderEnabled: false,

      forecast: false,
      information: null,
      himalayan_boundary: null,
      loading: false,
      missingDates: null,
      visibleDivPanel: false,
      loadingtab: false,
      defaultsubbasin: false,
      subbasin: null,
      dsubbasin: null,
      graphdata: null,
      basin: null,
      subbasinstate: null,
      stats: null,
      forecastdate: null,
      basininfo: null,
      stat_type: "Daily",
      riversystem: null,
      riverselected: "#",
      river_boundary: null,
      datesRange: "",
      river_basins: null,
      river_basin_selected: null,
      chart_categories: null,
      series_data: null,
      tabledata: null,
      tabledata_sub: null,
      lat:null,
      long:null,
      chartData_sub: null,
      tabledata_sub_range: null,

      startdate: "",
      enddate: "",
      technicalnoteenable: false,
      disclaimerenable: false,
      //=============================================================ALL THESE ADDED BY YOU NHP 2.0=============================================
      popup: {S_No_: "", River: null, River_Basin:null, index: null},
      rchartData: null,
      chartData: null,
      DischargePoint:null,
      date_snow:'#',
      arraycheck: [],
      swipevalue: 1,
      legend_array_overlay: {},

      // OVERLAY LAYERS- PURPLE
      // basinoverlays: [
      //   { id: 1, value: "Glaciers", isChecked: false },
      //   { id: 2, value: "Basins", isChecked: false },
      //    { id: 3, value: "Discharge Outlets", isChecked: false },
      //   { id: 4, value: "River", isChecked: false },
      // ],

      basinoverlays: [
        { id: 1, value: "GlacierBlue", isChecked: false },
        { id: 2, value: "Basin", isChecked: false },
         { id: 3, value: "DischargeOutlet", isChecked: false },
        { id: 4, value: "River", isChecked: false },
      ],
      startdate_scf:"",
      enddate_scf:"",
      popup: {gid: "", river: null, river_basin:null},
      start:null,
      end:null,
    
      selectedMonthStart: '',
      selectedMonthEnd: '',
      timestampselected:"#",
    };
  }

  
  toggleOverlayTab = () => {
    this.setState(prevState => ({
      overlayTabOpen: !prevState.overlayTabOpen
    }));
  };
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//Handling Left Swipe and Right Swipe Layers 
// both swipeuploadleft or swipeuploadright is not required, take reference from any of the two.
handleSwipeUploadLeft = () => {
  let workspace, layer, snowproductname,compareleftDateForLayer,compareLeftDate;
  
  if (this.state.snowproductselected === "Daily Snow Cover") {
      snowproductname = "Daily Snow Cover";  
      workspace = "nhp_daily-snow-cover";
      layer = workspace + ":snowcover_" + this.state.compareleftDateForLayer ;
     // console.log("swipeleftdaily",workspace,layer)
  }
  
  else if (this.state.snowproductselected === "Snow Cover Fraction") {
      snowproductname = "Snow Cover Fraction";
      workspace = "nhp_snow-cover-fraction";
      layer = workspace + ":nhp_snf_"+ this.state.compareleftDateForLayer;
     // console.log("swipeleftsnowcoverfraction",workspace,layer)
  }
  
  else if (this.state.snowproductselected === "Snowmelt Rate Forecast") {
    snowproductname = "Snowmelt Rate Forecast (3days)";
    workspace = "nhp_forecast";
    
    // Constructing the file names
    const fileName = "nhp_smf_" + this.state.compareleftDateForLayer + "_" + this.state.compareRightDateForLayer;
   // console.log("fractionlayerrrrrrrr", fileName); 

    // Splitting the file names by underscores to extract the dates
    const parts = fileName.split("_");
    //console.log("fractionlayerparts:", parts);
    // Extracting the dates from the parts array
    const forecastedDate = parts[2]; // Extracting the forecasted date
    const actualDate = parts[3]; // Extracting the actual date

    // Constructing the layer name using both dates
    const layer = workspace + ":nhp_smf_" + forecastedDate + "_" + actualDate;
    
    //console.log("swipeleftforecast", workspace, layer);
}
  else if (this.state.snowproductselected === "Daily Snowmelt Rate") {
      snowproductname = "Daily Snowmelt Rate (Potential)";
      workspace = "nhp_actual";
      layer = workspace + ":nhp_sma_"+ this.state.compareleftDateForLayer ;
     // console.log("swipeleftactual",workspace,layer)
  }
  
}


handleSwipeLeftDateChange = (e) => {
  let compareLeftDate = e;
  if (compareLeftDate !== null) {
      let mon = new Date(e).getMonth() + 1; // January is represented by 0
      let month = mon < 10 ? '0' + mon : mon.toString(); // Checks if month is less than 10, to make it 2-digit. Eg: 01, 02, etc.
      let year = new Date(e).getFullYear();
      let days = new Date(e).getDate();
      let day = days < 10 ? '0' + days : days.toString(); // Checks if day is less than 10

      let workspace, layer;

      if (this.state.snowproductselected === "Daily Snow Cover") {
          workspace = "nhp_daily-snow-cover";
          layer = workspace + ":snowcover_" + year + month + day;
      } else if (this.state.snowproductselected === "Snow Cover Fraction") {
          workspace = "nhp_snow-cover-fraction";
          layer = workspace + ":nhp_snf_" + year + month + day;
      } else if (this.state.snowproductselected === "Snowmelt Rate Forecast") {
          workspace = "nhp_forecast";
          layer = workspace + ":nhp_smf_" + year + month + day + "_"+ year + month + day;
         // console.log("werrrr",workspace,layer)
      } else if (this.state.snowproductselected === "Daily Snowmelt Rate") {
          workspace = "nhp_actual";
          layer = workspace + ":nhp_sma_" + year + month + day;
      }

     // console.log("panelcheckleft", day, year, month, workspace, layer);

      this.setState({
          compareLeftDate: e,
          compareleftDateForLayer: year + month + day,
          compareLeftWorkspace: workspace,
          compareLeftLayer: layer,
          
      });
    //  this.getAvailableDates_url();
  }
}


handleSwipeRightDateChange=(e)=>{
//  console.log("comppright",new Date(e),this.state.selectedMenu,this.state.snowproductselected)
  let compareRightDate=e;
  if(compareRightDate!==null)
  {  
    let mon = new Date(e).getMonth() + 1; // January is represented by 0
    let month = mon < 10 ? '0' + mon : mon.toString(); // Checks if month is less than 10, to make it 2-digit. Eg: 01, 02, etc.
    let year = new Date(e).getFullYear();
    let days = new Date(e).getDate();
    let day = days < 10 ? '0' + days : days.toString(); // Checks if day is less than 10

    let workspace, layer;

    if (this.state.snowproductselected === "Daily Snow Cover") {
        workspace = "nhp_daily-snow-cover";
        layer = workspace + ":snowcover_" + year + month + day;
    } else if (this.state.snowproductselected === "Snow Cover Fraction") {
        workspace = "nhp_snow-cover-fraction";
        layer = workspace + ":nhp_snf_" + year + month + day;
    } else if (this.state.snowproductselected === "Snowmelt Rate Forecast") {
        workspace = "nhp_forecast";
        layer = workspace + ":nhp_smf_" + year + month + day + "_"+ year + month + day;
    } else if (this.state.snowproductselected === "Daily Snowmelt Rate") {
        workspace = "nhp_actual";
        layer = workspace + ":nhp_sma_" + year + month + day;
    }

   // console.log("panelcheckright", day, year, month, workspace, layer);

    this.setState({
      compareRightDate: e,
      compareRightDateForLayer: year + month + day,
      compareRightWorkspace: workspace,
      compareRightLayer: layer,
  })
  // this.getAvailableDates_url(workspace);
    }
  }





  
// handleSwipeUploadRight = () => {
//   let workspace, layer, snowproductname;
 

//   if (this.state.snowproductselected === "Daily Snow Cover") {
//       snowproductname = "Daily Snow Cover";  
//       workspace = "nhp_daily-snow-cover";
//       layer = workspace + ":snowcover_" + this.state.compareRightDateForLayer;
//   }
//   else if (this.state.snowproductselected === "Snow Cover Fraction") {
//       snowproductname = "Snow Cover Fraction";
//       workspace = "nhp_snow-cover-fraction";
//       layer = workspace + ":nhp_snf_"+ this.state.compareRightDateForLayer;
//   }
//   else if (this.state.snowproductselected === "Snowmelt Rate Forecast (3days)") {
//       snowproductname = "Snowmelt Rate Forecast (3days)";
//       workspace = "nhp_forecast";
//       layer = workspace + ":nhp_smf_"+ this.state.compareRightDateForLayer;
//   } 
//   else if (this.state.snowproductselected === "Daily Snowmelt Rate (Potential)") {
//       snowproductname = "Daily Snowmelt Rate (Potential)";
//       workspace = "nhp_actual";
//       layer = workspace + ":nhp_sma_"+ this.state.compareRightDateForLayer;
//   }

//   this.setState({
//       compareRightWorkspace: workspace,
//       compareRightLayer: layer, 
//   });
// }

//============================================Created Today for SWIPE LEFT DATE AND SWIPE RIGHT DATE===============================================================//
  

// handleSwipeLeftDateChange=(e)=>{
//     console.log("comppleft",new Date(e),this.state.selectedMenu,this.state.snowproductselected)
//     let compareLeftDate=e;
//     let workspace,layer;
//     if(compareLeftDate!==null)
//     { 
//       let mon=new Date(e).getMonth()+1 //January is represented by 0
//       let month = mon < 10 ? '0' + mon : mon.toString(); // checks if month is less than 10, to make it 2-digit. Eg: 01,02 and so on.
//       let year=new Date(e).getFullYear()
//       let days=new Date(e).getDate()
//       let day = days < 10 ? '0' + days : days.toString(); // checks if day is less than 10
//       console.log("panelcheckleft",day,year,month)
    
//     this.setState({
//      compareLeftDate:e,
//      compareleftDateForLayer:year+month+day,
//      workspace:workspace,
//      layer:layer,
//     })
//       }
//     }



  
  // handleSwipeRightDateChange=(e)=>{
  //     console.log("comppright",new Date(e),this.state.selectedMenu,this.state.snowproductselected)
  //     let compareRightDate=e;
  //     if(compareRightDate!==null)
  //     {  
  //       let mon=new Date(e).getMonth()+1 //January is represented by 0, feb as 1...
  //       let month = mon < 10 ? '0' + mon : mon.toString(); // checks if month is less than 10
  //       let year=new Date(e).getFullYear()
  //       let days=new Date(e).getDate()
  //       let day = days < 10 ? '0' + days : days.toString(); // checks if day is less than 10
  //       console.log("panelcheckright",day,month,year)
      
  //     this.setState({
  //      compareRightDate:e,
  //      compareRightDateForLayer:year+month+day
  //     })
  //       }
  //     }

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      handleDragStop = (e, d) => {
        //console.log("draggable mode-----------",e,d)
        if (this.state.isDraggingAllowed) {
        
        }
      }
  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 20;
    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14`;
    return img_src;
  }


  getIndiaStatesBoundary = () => {
    axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
      if (result) {
        this.setState({
          india_states_boundary: result.data[0].india_boundary,
        });
      }
    });
  };
  getLegend = (overlay) => {
    let wms_url = this.state.wms_url;
    let legend_array_overlay = {};
    overlay.map((layer) => {
      if (layer.isChecked) {
        this.getLegendGraphic(wms_url, "nhp_snowcomponent:" + layer.value).then(
          (legend) => {
           // console.log("rammmmm",legend);
            legend_array_overlay[layer.value] = legend;
            this.setState({
              legend_array_overlay: legend_array_overlay,
              legendVisible: true,
            });
          }
        );
      } else {
        this.setState({
          legend_array_overlay: null,
          legendVisible: true,
        });
      }
      return true;
    });
  };
          
  handleCheckChieldElement = (event) => {
    const isChecked = event.target.checked;
    const value = event.target.value;
  
    // Split the combined value into separate layers
    const layers = value.split('_');
  
    let updatedOverlays = this.state.basinoverlays.map((overlay) => {
      if (layers.includes(overlay.value)) { // Check if overlay value is in the layers array
        overlay.isChecked = isChecked;
      }
      return overlay;
    });
  
    this.getLegend(updatedOverlays);
    this.setState({ basinoverlays: updatedOverlays });
  };
  

 
  

  updateTabs = (id) => {
   ////console.log("jjj",id);
    let tabs = this.state.tabs;
    let newtabs = tabs.map((tab, index) => {
      if (tab.id === id) {
        if (tab.active === true) {
          tab.active = false;
        } else {
          tab.active = true;
        }
      } else {
        tab.active = false;
      }
      return tab;
    });
   ////console.log(newtabs);
    return newtabs;
  };

  handleTimestampChange=(e)=>
  {
      this.setState({
        timestampselected:e.target.value, 
        buttonColor:"white",
      })

  }
  handleTabClick = (id) => {
  // //console.log(id);
    this.setState({ tabs: this.updateTabs(id) ,collapsed3:false});
  };
  handleClick_Stats = (e, titleProps) => {
   ////console.log("vvvvv----",e,"\nTITLEPORP--------------------------",titleProps)
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    if (index === 1) {
      this.getBaseLayer_boundary();
      this.setState({
        riverselected: "#",
        river_basins:null,
        river_basin_selected: "#",
        river_boundary: null,
        tabledata: null,
        daily_stats: null,
        visibleTableData: false, 
        visibleGraphPanel_pie: false,
      });
    } else if (index === 0) {
      this.getRiverStats();
      this.getBaseLayer_boundary();
      this.setState({
        activeIndex: newIndex,
        riverselected: "#",
        river_basin_selected: "#",
        visibleGraphPanel_pie: true,
        graphenable: true,
        visibleTableData: true,
        tableenable: false,
        visibleGraphPanel: false,
      });
    }
    this.setState({
      activeIndex: newIndex,
      riverselected: "#",
      river_basin_selected: "#",
    });
  };
  displayBaseLayers = () => {
   ////console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
      legendVisible: false,
      visibleGraphPanel_pie:false,



    });
  
  };
  displayLegend = () => {
    this.setState({ legendVisible: !this.state.legendVisible,
      visibleGraphPanel_pie: false,//!this.state.visibleGraphPanel_pie,
      baseLayers:false,

     });
   
  };
  toggleVisibleGraphPanel = () => {
    if (this.state.chartData || this.state.chartData_sub) {
      this.setState({
        visibleGraphPanel: !this.state.visibleGraphPanel,
        technicalnoteenable: false,
        disclaimerenable: false,
        

      });
    }
  };

  toggleVisibleGraphPanel_pie = () => {
    if (this.state.daily_stats || this.state.tabledata) {
      this.setState({
        visibleGraphPanel_pie: !this.state.visibleGraphPanel_pie,
        technicalnoteenable: false,
        disclaimerenable: false,
        baseLayers:false,
        legendVisible: false,
      });

    }
   

  };
  toggleTableData = () => {
    if (this.state.tabledata) {
      this.setState({
        visibleTableData: !this.state.visibleTableData,
      });
    }
  };
  toggleDivPanel = () => {
    this.setState({
      visibleDivPanel: !this.state.visibleDivPanel,
    });
  };
  handleVisibleGraphPanelOnMapClick = () => {
    this.setState({
      visibleGraphPanel: true,
    });
  };
  setDate = (date) => {
    this.setState({
      activeDate: date,
    });
  };
  onUpdateBasin = (result) => {
    
    
    //console.log(result);
    this.setState({
      basininfo: result,
    });
  };
  toggleSelectedNodeStatus = (menu) => {
    let selectedNodeStaus = { ...this.state.selectedNodeStatus };
    selectedNodeStaus[menu] = !selectedNodeStaus[menu];

    this.setState({
      selectedNodeStaus: selectedNodeStaus,
    });
  };

  enableDatePicker = (status) => {
    this.setState({
      dateEnabled: status,
    });
  };
  enableForecast = (status) => {
    this.setState({
      forecast: status,
    });
  };
  enableSlider = (status) => {
    this.setState({
      sliderEnabled: status,
    });
  };

  handleAnimationChange = () => {
    this.setState({
      visible: !this.state.visible,
      
    });
  };
 

  setSelectedMenu = (menu) => {
    this.setState({
      selectedMenu: menu,
      visibleGraphPanel: false,
    });
    let string = menu.toLowerCase().split(" ").join("-");
   //console.log("worKiiiiiiiiiii stringrrrrr",string);

    if (string !== "spatial-snowmelt") this.getAvailableDates_url(string);
    if (string === "daily-snow-cover") {
      this.getStats();
      this.getRiverStats();
    }
    if (string === "daily-snow-cover") {
      this.setState({
        selectedMenu: menu,
        visibleGraphPanel: false,
        visibleGraphPanel_pie: true,
        legendVisible: true,
        latlng: null,
        activeIndex: 0,
        river_basin_selected: "#",
        riverselected: "#",
      });
    } else {
      this.getBaseLayer();
      this.setState({
        visibleGraphPanel: false,
        visibleGraphPanel_pie: false,
        legendVisible: true,
        chartData: null,
        tabledata: null,
        visibleTableData: false,
        latlng: null,
      });
    }
  };

  getStats = () => {
    this.setState({ loadingtab: true }, () =>
      axios
        .get(`${domain.DBServer}/fetch-stats-all-basins-default`)
        .then((result) => {
          if (result) {
            this.setState({
              stats: result.data,
              loadingtab: false,
            });
          }
        })
    );
  };

  setSelectedLayer = (main) => {
    let selectedLayer = { ...this.state.selectedLayer };
   //console.log(main);
    if (main) {
      if (main.split("_")[0] !== "Forecast") {
        if (new URLSearchParams(this.props.location.search).get("date")) {
          selectedLayer[main] =
            moment(
              new URLSearchParams(this.props.location.search).get("date"),
              "DD-MM-YYYY"
            ).format("YYYYMMDD") + file_ext[main];
        } else {
          selectedLayer[main] =
            file_ext[main] +
            moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
        }
        this.setState({
          selectedLayer: selectedLayer,
        });
      } else if (main === "Forecast") {
        selectedLayer[main] =
          file_ext[main] +
          moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD") +
          "_" +
          moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
        this.setState({
          selectedLayer: selectedLayer,
          forecastdate: this.state.date,
        });
      } else if (main.split("_")[0] === "Forecast") {
        selectedLayer[main.split("_")[0]] =
          file_ext[main.split("_")[0]] +
          moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD") +
          "_" +
          moment(main.split("_")[1], "DD MMM YYYY").format("YYYYMMDD");

        this.setState({
          selectedLayer: selectedLayer,
          forecastdate: moment(main.split("_")[1], "DD MMM YYYY").format(
            "DD-MM-YYYY"
          ),
        });
      }
    }
  };

  setStateInfo = (info) => {
    this.setState({
      stateInfo: info,
    });
  };

  setLegend = (src) => {
    this.setState({
      legend: src,
    });
  };

  setLatLng = (latlng) => {
    this.setState({
      latlng: latlng,
      lat:latlng.lat,
      long:latlng.lng,
    });

   //console.log("latlong--------------------------",latlng,this.state.lat,this.state.long)
  };

  setOnClickDetails = (data) => {
    this.setState({
      onClickDetails: data,
    });
  };

  makeChartDataAvailableDaysWithDateCats = (
    lat,
    longitude,
    start,
    end,
  ) => {
    this.setState({ chartloading: false, chartData: null });
    let availableDatesStr = [],
      chartData = [];
    let chartDates = [];
   //console.log("boom-----------", longitude, lat,start,end);

    let url = this.state.selectedMenu.toLowerCase().split(" ").join("-");
    axios
        .get(`${domain.DBServer}/fetch-${url}-SDED/${longitude}/${lat}/${start}/${end}`)
      .then((result) => {
       ////console.log("aaaaaaa",result.data);
        result.data.map((r) => {
          availableDatesStr.push(moment(r.date).format("YYYYMMDD"));
          return true;
        });
        result.data.map((r) => {
          chartData.push(Number(r.value));
          return true;
        });
       //console.log("bbbbbb",chartData.length);
        availableDatesStr.forEach((date_i) => {
          chartDates.push(moment(date_i, "YYYYMMDD").format("D MMM YYYY"));
          return true;
        });
       //console.log("ooooooooo",chartDates);

        let data2 = [];
        for (let i = 0; i < chartDates.length; i++) {
          let dd = new Date(chartDates[i]);
         //console.log(dd);
          let y = dd.getFullYear();
          let m = dd.getMonth();
          let d = dd.getDate();
          data2.push([Date.UTC(y, m, d), chartData[i]]);
        }
        data2.sort();
       //console.log("rihhhhhhh",data2);
        this.setState({
          pointInfo: chartData[0],
          chartloading: false,
          technicalnoteenable: false,
          disclaimerenable: false,
          chartData: {
            seriesData: data2,
            categories: chartDates,
            excel: "Snow Cover Fraction (%)",


           title: `Snow Cover Fraction from ${moment(
            start,
            "DD-MM-YYYY"
          ).format("DD MMMM YYYY")} to ${moment(end, "DD-MM-YYYY").format(
            "DD MMMM YYYY"
          )}`,
// HERE YOU EDITED COLUMN NAME- WHEN YOU DOWNLOAD THE GRAPH, THIS COLUMN WILL APPEAR NOW, THIS ALSO SHOWS CHART INSIDE CONTENTS LIKE TOOLTIP
            yAxisTitle: `Snow Cover Fraction (%)`,
            xAxisTitle: "Days",
           //THIS NAME WILL CHANGE TOOLTIP TITLE- as well download graph column name
            name:"Snow Cover Fraction (%)",

            type: "bar",
            units: "%",
          },
        });
      });
  };
  
  async doesLayerExist(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",
      },
      withCredentials: true,
    });

    if (result.data.layerDescriptions !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  async describeLayer(layer, wms_url) {
    let result = await axios.get(wms_url, {
      params: {
        request: "DescribeLayer",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        layers: layer,
        output_format: "application/json",
        exceptions: "application/vnd.ogc.se_xml",
      },
      withCredentials: true,
    });
    return result.data;
  }

  async getFeatureInfo(wms_url) {
    let result = await axios.get(wms_url);
    return new Promise((resolve) => {
      resolve(result);
    });
  }

  getAvailableDates_url = (workspace) => {
   //console.log("workiiiiiiiii",workspace)
    let availableDates = [];
    axios.get(`${domain.DBServer}/fetch-${workspace}`).then((result) => {
      if (result && result.data) {
        result.data.map((r) => {
         //console.log("mlllll",r.date);
          availableDates.push(moment(r.date));
          return true;
        });
       //console.log("checkavaillllllllllllllllllllll",availableDates);
  
        let maxdate = moment.max(availableDates).format("DD-MM-YYYY");
       //console.log("pyyyyyy",maxdate);
        let mindate = moment.min(availableDates).format("DD-MM-YYYY");
       //console.log("lyyyyyy",mindate);
        let sortedDates = availableDates.sort(
          (a, b) => a.valueOf() - b.valueOf()
        );
  
        this.setState({                            
          availableDates: sortedDates,
          date: maxdate,
          startdate: mindate,
          enddate: maxdate,
          slideTracker: sortedDates.length - 1,
          loading: true,
          date_snow:maxdate,
          compareLeftDate: null,
          compareRightDate:null // Reset the selected date after fetching new dates
        });
      }
    });
  };
                                

  common_river_func = async (river) => {
    this.setState({
      tabledata: null,
      daily_stats: null,
    });
    let categories = [],
      series = [];
    var d = new Date(moment(this.state.date, "DD-MM-YYYY"));
    var str_date = change_date(d);
    let result_c = await fetchRiverBasinStats(river, str_date);
   //console.log("massssss",result_c.data);
    if (result_c) {
      result_c.data.map((result) => {
        categories.push(result.basin);
        return true;
      });
      result_c.data.map((result) => {
        series.push(Number(result.count));
        return true;
      });

      ///JUST TO CREATE A BETTER TABLE DOWNLOAD FORMAT, THESE LINES
      this.setState({
        // riversystem:result.data,
        tabledata: result_c.data,
        daily_stats: {
          
          name: "Daily Snow Cover Area",
          title: `Daily Snow Cover Area on ${moment(
            this.state.date,
            "DD-MM-YYYY"
          ).format("DD MMMM YYYY")}`,
          categories: categories,
          seriesData: series,
          type: "pie",
          //yAxisTitle: "Snow Cover Area (sq.km)",
         // xAxisTitle: "River ",
        },

        visibleGraphPanel_pie: true,
        visibleTableData: true,
        graphenable: true,
        tableenable: false,
        visible:window.innerWidth>1000?true:false
      });
    }
  };
  common_chart_func = async (value) => {
    this.setState({
      tabledata: null,
      daily_stats: null,
    });
    let categories = [],
      series = [];

   //console.log(value);
    if (this.state.selectedMenu === "Daily Snow Cover") {
      let result_b = await fetchRiverStats(value);
     //console.log("eassssss",result_b.data);
      if (result_b) {
        result_b.data.map((result) => {
          categories.push(result.basin);
          return true;
        });
        result_b.data.map((result) => {
          series.push(Number(result.count));
          return true;
        });

       //console.log(value);
        this.setState({
          tabledata: result_b.data,
          daily_stats: {
            name: "Daily Snow Cover Area",
            title: `Daily Snow Cover Area on ${moment(
              value,
              "DD-MM-YYYY"
            ).format("DD MMMM YYYY")}`,
            categories: categories,
            seriesData: series,
            type: "pie",
           // yAxisTitle: "Snow Cover Area (sq.km)",
          //  xAxisTitle: "River ",
          },
          visibleGraphPanel_pie: true,
          visibleTableData: true,
          tableenable: false,
          graphenable: true,
          visible:window.innerWidth>1000?true:false
        });
      }
    }
  };

  handleDateChange = async (event, { name, value }) => {
    let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let availableDates = [...this.state.availableDates];
    let availableDatesStr = availableDates.map((date) => {
      return moment(date, "DD-MM-YYYY").format("YYYYMMDD");
    });
   //console.log("whatdate",selected_date);
   //console.log("whatavail",availableDates);
   //console.log("whatavailstrrr",availableDatesStr);
    selectedLayer[this.state.selectedMenu] =
      file_ext[this.state.selectedMenu] + selected_date;
     //console.log("what selectedlayer",selectedLayer[this.state.selectedMenu])

    if (this.state.riverselected !== "#" && this.state.activeIndex === 0)
      this.common_river_func(this.state.riverselected);
    else this.common_chart_func(value);
    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,
        selectedLayer: selectedLayer,
        slideTracker: availableDatesStr.indexOf(selected_date),
        layerExist: true,
        loading: false,
        inlinemode:false,
        date_snow:selected_date
      });
    } 
}
  onSlide = (event) => {
    event.preventDefault();
    let value = parseInt(event.target.value, 10);
    let selected_date = moment(
      this.state.availableDates[value],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    selectedLayer[menu] = file_ext[menu] + selected_date;

    var d = new Date(moment(this.state.availableDates[value], "DD-MM-YYYY"));
    var str_date = change_date(d);
   //console.log(str_date);

    if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0 &&
      this.state.riverselected !== "#"
    )
      this.common_river_func(this.state.riverselected);
    else if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0
    )
      this.common_chart_func(str_date);

    this.setState({
      slideTracker: value,
      date: this.state.availableDates[value],
      selectedLayer: selectedLayer,
    });
  };

setlatlong=(lat,long)=>{
  this.setState({
    lat:lat,
    long:long,
  })
}
  onClickSlideLeft = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker > 0) {
      slideTracker = slideTracker - 1;
    }
    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = file_ext[menu] + selected_date;
    // })
    var d = new Date(
      moment(this.state.availableDates[slideTracker], "DD-MM-YYYY")
    );
    var str_date = change_date(d);
   //console.log(str_date);

    if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0 &&
      this.state.riverselected !== "#"
    )
      this.common_river_func(this.state.riverselected);
    else if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0
    )
      this.common_chart_func(str_date);
   //console.log(selectedLayer);
    this.setState({
      slideTracker: slideTracker,
      date: str_date,
      selectedLayer: selectedLayer,
    });
  };

  onClickSlideRight = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker < this.state.availableDates.length - 1) {
      slideTracker = slideTracker + 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = file_ext[menu] + selected_date;
    // })
    var d = new Date(
      moment(this.state.availableDates[slideTracker], "DD-MM-YYYY")
    );
    var str_date = change_date(d);
    if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0 &&
      this.state.riverselected !== "#"
    )
      this.common_river_func(this.state.riverselected);
    else if (
      this.state.selectedMenu === "Daily Snow Cover" &&
      this.state.activeIndex === 0
    )
      this.common_chart_func(str_date);
    this.setState({
      slideTracker: slideTracker,
      date: str_date,
      selectedLayer: selectedLayer,
    });
  };
  getBaseLayer = () => {
    axios.get(`${domain.DBServer}/get-himalayan-boundary`).then((result) => {
      if (result) {
        this.setState({
          himalayan_boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
  };

  getBaseLayer_boundary = () => {
    axios.get(`${domain.DBServer}/get-himalayan-boundary`).then((result) => {
      if (result) {
        this.setState({
          river_boundary: result.data[0].himalayan_boundary,
          loading: true,
        });
      }
    });
  };
  setDefaultInfo = (text) => {
    this.setState({
      information: text,
    });
  };

  getRiverStats = async () => {
    let categories = [],
      series = [],
      dates = [];
    let result = await fetchHRivers();
    let result_b = await fetchRiverStatsDefault();
   //console.log("cvbbbb",result_b);
    if (result && result_b) {
      result_b.data.map((result) => {
        categories.push(result.basin);
        return true;
      });
      result_b.data.map((result) => {
        series.push(Number(result.count));
        return true;
      });
      result_b.data.map((result) => {
        dates.push(result.snowcover_date);
        return true;
      });
     //console.log("abc",series, categories, dates);
      let date = moment(dates[0]).format("DD-MM-YYYY");
      this.setState({
        
        riversystem: result.data,
        tabledata: result_b.data,
        daily_stats: {
          name: "Daily Snow Cover Area",
          title: `Daily Snow Cover Area on ${moment(date, "DD-MM-YYYY").format(
            "DD MMMM YYYY"
          )}`,
          categories: categories,
          seriesData: series,
          type: "pie",
          //yAxisTitle: "FJXFGJNFN (sq.km)",
         // xAxisTitle: "River ",
        },

        visibleGraphPanel_pie: true,
        visibleTableData: true,
        tableenable: false,
        graphenable: true,
        visible:window.innerWidth>1000?true:false
      });
    }
  };

  handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex });
  handleRowClick = (result) => {
    this.setState({
      activeIndex: 1,
      subabsindata: result,
    });
  };

  changeRiverName = async (e) => {
   //console.log("rain",this.state.river_basin_selected);
    let river = e.target.value;

    if (river !== "#") {
      let categories = [],
        series = [];

      let result = await fetchHRiverBoundary(river);
      let result_b = await fetchHBasins(river);
      this.setState({
        chartData: null,
        tabledata: null,
        daily_stats: null,
        river_basins: null,
        river_basin_selected: "#",
      });
      if (this.state.activeIndex === 0) {
        var d = new Date(moment(this.state.date, "DD-MM-YYYY"));
        var str_date = change_date(d);
        let result_c = await fetchRiverBasinStats(river, str_date);
       //console.log(result_c.data);
        if (result_c) {
          result_c.data.map((result) => {
            categories.push(result.basin);
            return true;
          });
          result_c.data.map((result) => {
            series.push(Number(result.count));
            return true;
          });

          this.setState({ 
            // riversystem:result.data,
            tabledata: result_c.data,
            daily_stats: {
           
              name: "Daily Snow Cover Area",
              title: `Daily Snow Cover Area on ${moment(
                this.state.date,
                "DD-MM-YYYY"
              ).format("DD MMMM YYYY")}`,
              units: " km²",
              categories: categories,
              seriesData: series,
              type: "pie",
            //  yAxisTitle: "Snow Cover Area (sq.km)",
            //  xAxisTitle: "River ",
            },

            visibleGraphPanel_pie: true,
            visibleTableData: true,
            tableenable: false,
            graphenable: true,
            visible:window.innerWidth>1000?true:false
          });
        }
      } else if (this.state.activeIndex === 1) {
        this.timeSeriesRiverStats(river);
      }
      this.setState({
        river_boundary: result.data[0].basin_boundary,
        riverselected: river,
        river_basins: result_b.data,
        river_basin_selected: "#",
      });
    } else {
      this.getBaseLayer_boundary();
      this.setState({
        riverselected: river,
        river_boundary: null,
        visibleGraphPanel: false,
        river_basins: null,
        river_basin_selected: "#",
      });

      var d = new Date(
        moment(this.state.availableDates[this.state.slideTracker], "DD-MM-YYYY")
      );
      var str_date = change_date(d);
      if (
        this.state.selectedMenu === "Daily Snow Cover" &&
        this.state.activeIndex === 0
      )
        this.common_chart_func(str_date);
    }
  };
 
  changeRiverBasin = async (e) => {
    let basin = e.target.value;
    if (basin !== "#") {
      let result = await fetchHRiverBasinBoundary(
        this.state.riverselected,
        basin
      );
      this.timeSeriesRiverBasinStats(basin);
      this.setState({
        river_boundary: result.data[0].basin_boundary,
        river_basin_selected: basin,
      });
    } else {
      let result = await fetchHRiverBoundary(this.state.riverselected);
      this.setState({
        river_boundary: result.data[0].basin_boundary,
      });

      this.timeSeriesRiverStats(this.state.riverselected);
    }
  };

  toggleSnowCover = () => {
    this.setState({
      tableenable: !this.state.tableenable,
      graphenable: !this.state.graphenable,
    });
  };
//===============================================================================================================================================================
//=================================================TIMESERIES FOR RIVER SELECTION with START-END DATE-23 JAN (DAILY SNOW COVER)==================================
// IF YOU WANT TO CHANGE ANY CONTENTS RELATED TO GRAPH DOWNLOAD, EDIT HERE- For eg. (sq.km)
timeSeries_river_common_func = async (value, start_date, end_date) => {
  let categories = [],
    series = [],
    chartData = [];
 //console.log("theenddddd",start_date, end_date);
  if (
    moment(end_date, "DD-MM-YYYY").diff(
      moment(start_date, "DD-MM-YYYY"),
      "days"
    ) >= 0
  ) {
    let startdate =
      start_date !== null
        ? moment(start_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : moment(this.state.startdate, "DD-MM-YYYY").format("DD-MM-YYYY");
    let enddate =
      end_date !== null
        ? moment(end_date, "DD-MM-YYYY").format("DD-MM-YYYY")
        : moment(this.state.enddate, "DD-MM-YYYY").format("DD-MM-YYYY");

    let result_b = await fetchRiverStatsByDates(value, start_date, end_date);
   //console.log(result_b);
    if (result_b) {
      result_b.data.map((result) => {
        series.push(Number(result.sum));
        return true;
      });
      result_b.data.map((result) => {
        let cdate=moment(result.snowcover_date)
        categories.push(
          Date.UTC(
            parseInt(cdate.format("YYYY"), 10),
            parseInt(cdate.format("MM"), 10) - 1,
            parseInt(cdate.format("DD"), 10)
          ),
        );
        return true;
      });
      result_b.data.map((result) => {
        let cdate=moment(result.snowcover_date)
        chartData.push([
         Date.UTC(
          parseInt(cdate.format("YYYY"), 10),
          parseInt(cdate.format("MM"), 10) - 1,
          parseInt(cdate.format("DD"), 10)
        ),
          Number(result.sum).valueOf(),
        ]);
        return true;
      });
      let max = findMinMax(chartData);
      let maxvalue = chartData[max][1];
      let maxdate = chartData[max][0];
     //console.log(maxvalue, maxdate);
      chartData.sort();
     //console.log(chartData);
     
      this.setState({
     //====================================================================================================//
        // using this code, one can change downloaded table columns name
        tabledata: result_b.data,
        river_basin_selected: "#",
        chartData: {
          // categories:categories,
          seriesData: chartData,
          // seriesData:chartData,
          type: "bar",
          yAxisTitle: "Snow Cover Area (km²)",
          xAxisTitle: "River ",
          //name: "Daily Snow Cover Area (sq.km)",
          name: "Daily Snow Cover Area",
          excel: "Daily Snow Cover Area (sq.km)",


          units: "km²",
          maxdate: maxdate,
          maxvalue: maxvalue,
          title: `Daily Snow Cover Area of ${value} River System from ${moment(
            startdate,
            "DD-MM-YYYY"
          ).format("DD MMMM YYYY")} to ${moment(enddate, "DD-MM-YYYY").format(
            "DD MMMM YYYY"
          )}`,
        },
        chartloading: false,
        visibleGraphPanel: true,
        visible:window.innerWidth>1000?true:false
      });
    }
  } else {
    this.setState({
      visibleGraphPanel: false,
    });
    swal({
      title: `Message`,
      // width: 400,
      padding: "3em",
      text: " Please Check the dates",
    });
  }
};
//======================================================================================================================================================
//=====================================================TIMESERIES FOR BASIN SELECTION with START-END DATE- 23 JAN (DAILY SNOW COVER)====================
// IF YOU WANT TO CHANGE ANY CONTENTS RELATED TO GRAPH DOWNLOAD, EDIT HERE- For eg. (sq.km)
  timeSeries_river_basin_common_func = async (value, start_date, end_date) => {
    let categories = [],
      series = [],
      chartData = [];
   //console.log("cccccstaaaa",start_date, end_date);
    if (
      moment(end_date, "DD-MM-YYYY").diff(
        moment(start_date, "DD-MM-YYYY"),
        "days"
      ) >= 0
    ) {
      let startdate =
        start_date !== null
          ? moment(start_date, "DD-MM-YYYY").format("DD-MM-YYYY")
          : moment(this.state.startdate, "DD-MM-YYYY").format("DD-MM-YYYY");
      let enddate =
        end_date !== null
          ? moment(end_date, "DD-MM-YYYY").format("DD-MM-YYYY")
          : moment(this.state.enddate, "DD-MM-YYYY").format("DD-MM-YYYY");

     //console.log("what",enddate, startdate);
      let result_b = await fetchRiverBasinStatsByDates(
        this.state.riverselected,
        value,
        startdate,
        enddate
      );
     //console.log(result_b);
      if (result_b) {
        result_b.data.map((result) => {
          series.push(Number(result.sum));
          return true;
        });
        result_b.data.map((result) => {
          let cdate=moment(result.snowcover_date)
          categories.push(
            Date.UTC(
              parseInt(cdate.format("YYYY"), 10),
              parseInt(cdate.format("MM"), 10) - 1,
              parseInt(cdate.format("DD"), 10)
            ),
          );
          return true;
        });
        result_b.data.map((result) => {
          let cdate=moment(result.snowcover_date)
          chartData.push([

           Date.UTC(
            parseInt(cdate.format("YYYY"), 10),
            parseInt(cdate.format("MM"), 10) - 1,
            parseInt(cdate.format("DD"), 10)
          ),
            Number(result.sum).valueOf(),
          ]);
          return true;
        });

        let max = findMinMax(chartData);
       //console.log(max);
        let maxvalue = chartData[max][1];
        let maxdate = chartData[max][0];
       //console.log(maxvalue, maxdate);
        chartData.sort();
       //console.log(chartData);
        this.setState({
          chartData: {
            seriesData: chartData,
            type: "bar",
            yAxisTitle: "Snow Cover Area (km²)",
            xAxisTitle: "River ",
            excel: "Daily Snow Cover Area (sq.km)",
            
          // name: "Daily Snow Cover Area(sq.km)",
            name: "Daily Snow Cover Area(km²)",

            units: " km² ",
            maxdate: maxdate,
            maxvalue: maxvalue,
            title: `Daily Snow Cover Area of ${value} Basin from ${moment(
              startdate,
              "DD-MM-YYYY"
            ).format("DD MMMM YYYY")} to ${moment(enddate, "DD-MM-YYYY").format(
              "DD MMMM YYYY"
            )}`,
          },

          visibleGraphPanel: true,
          visible:window.innerWidth>1000?true:false
        });
      }
    } else {
      this.setState({
        visibleGraphPanel: false,
      });
      swal({
        title: `Message`,
        // width: 400,
        padding: "3em",

        text: " Please Check the dates",
      });
    }
  };

//================================================RIVER STATS AND RIVERBASIN STATS=================================================
//==================================================================================================================================
  timeSeriesRiverStats = (value, opts) => {
    this.setState({
      river_basin_selected: "#",
      chartloading: true,
      chartData: null,
    });
    if (opts !== undefined) {
      if (opts["method"] === "startdate")
        this.timeSeries_river_common_func(
          value,
          opts["value"],
          this.state.enddate
        );
      else if (opts["method"] === "enddate")
        this.timeSeries_river_common_func(
          value,
          this.state.startdate,
          opts["value"]
        );
    } else if(this.state.selectedMenu==="Daily Snow Cover") {
      this.timeSeries_river_common_func(
        value,
        this.state.startdate,
        this.state.enddate
      );
    }
  };

  timeSeriesRiverBasinStats = (value, opts) => {
    this.setState({ chartloading: true, chartData: null });
    this.setState({
      chartData: null,
      tabledata: null,
      chartData_sub: null,
      tabledata_sub: null,
    });
    if (opts !== undefined) {
      if (opts["method"] === "startdate") {
       //console.log(opts["value"]);
        this.timeSeries_river_basin_common_func(
          value,
          opts["value"],
          this.state.enddate
        );
      } else if (opts["method"] === "enddate") {
        this.timeSeries_river_basin_common_func(
          value,
          this.state.startdate,
          opts["value"]
        );
      }
    } else if (this.state.selectedMenu==="Daily Snow Cover") {
      this.timeSeries_river_basin_common_func(
        value,
        this.state.startdate,
        this.state.enddate
      );
    }
  };

handleStartDateChange = (event, { name, value }) => {
this.setState({
  chartData:null,
  chartDates:null,
  chartloading:false,
})
 //console.log("we are here---------------------- ",event,name,value)
  //event.preventDefault();
 //console.log(
 //   this.state.riverselected !== "#" &&
   //   this.state.river_basin_selected !== "#"
  //);
  if (
    this.state.riverselected !== "#" &&
    this.state.river_basin_selected !== "#" && this.state.selectedMenu==="Daily Snow Cover"
  ) {
   //console.log(
     // "herethere",
     // this.state.riverselected,
     // this.state.river_basin_selected
   // );
    this.timeSeriesRiverBasinStats(this.state.river_basin_selected, {
      method: "startdate",
      value: value,
    });
  } else if (
    this.state.river_basin_selected === "#" &&
    this.state.riverselected !== "#"  && this.state.selectedMenu==="Daily Snow Cover"
  ) {
    this.timeSeriesRiverStats(this.state.riverselected, {
      method: "startdate",
      value: value,
    });
   //console.log("this.state.start",this.state.startdate)
  }
  else if(this.state.selectedMenu==="Snow Cover Fraction"){
    this.makeChartDataAvailableDaysWithDateCats(this.state.lat,this.state.long,value,this.state.enddate)
  }
    if (this.state.hasOwnProperty(name)) {
    this.setState({ [name]: value });
  }
  
};
  handleEndDateChange = async (event, { name, value }) => {
   //console.log("lllllllllll-------------------",this.state.hasOwnProperty(name), this.state.selectedMenu)
    this.setState({
      chartData:null,
      chartDates:null,
      chartloading:false,
    
    })
   //console.log("kie",this.state.riverselected, this.state.river_basin_selected);
   //console.log(
     // this.state.riverselected !== "#" &&
     //   this.state.river_basin_selected !== "#"  
    //);
    if (
      this.state.riverselected !== "#" &&
      this.state.river_basin_selected !== "#"  && this.state.selectedMenu==="Daily Snow Cover"
    ) {
      this.timeSeriesRiverBasinStats(this.state.river_basin_selected, {
        method: "enddate",
        value: value,
      });
    } else if (
      this.state.river_basin_selected === "#" &&
      this.state.riverselected !== "#" && this.state.selectedMenu==="Daily Snow Cover"
    ) {
      this.timeSeriesRiverStats(this.state.riverselected, {
        method: "enddate",
        value: value,
      });
    }
    else if(this.state.selectedMenu==="Snow Cover Fraction"){
      this.makeChartDataAvailableDaysWithDateCats(this.state.lat,this.state.long,this.state.startdate,value)
    }

    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  };
  async componentDidMount() {
    this.getBaseLayer();
   //console.log(window.innerWidth);
    if(window.innerWidth <700)
    {
      this.setState({
        visible:false,
        legendVisible:false,
        x:0,
        y:0,
        width:300,
        height:300,
        date_snow:this.state.enddate,

      })
    }
  }
 

//YOU CREATED FOR OVERLAY CHECKBOXES and for COMPARE TOOL- YOU USED COLLAPSED3 BECAUSE YOUR COMPARISON TOOL DROPDOWN POSITION IS 3 AND YOU WANT THIS FEATURE TO OPEN WHEN THAT IS SELECTED======

  handleDateChangeRangeStart = (e) => {
   //console.log("datechangestarttttttttt",new Date(e).getMonth() + 1)
    this.setState({ selectedMonthStart: e,
      buttonColor:"white",
      selectedStrtMon:new Date(e).getMonth() + 1,
      selectedStrtYear:new Date(e).getFullYear(),

   });

  //console.log("start change after set",this.state.selectedMonthStart)
  };

  handleDateChangeRangeEnd = (e,) => {
   //console.log("datechangeendddddd",e)
    this.setState({ selectedMonthEnd:e,
      buttonColor:"white",
      selectedEndMon:new Date(e).getMonth() + 1,
    selectedEndYear: new Date(e).getFullYear()});
  };

/* Using this let tabs, you closed other tabs when collapsed3 is open*/
SwipeTool=()=>{
 //console.log('Inside SwipeTool');
  this.setState({
    collapsed3:!(this.state.collapsed3),
    collapsed:false,
    collapsed1:false,
    collapsed2:false,
    collapsed4:false,
    snowproductselected:"#",
    snowproductselectedR:"#",
    legend_array_overlay: {},
    chartData:null,
    visibleGraphPanel:false,
    river_boundary:null,

    //basinoverlays:{},
    basinoverlays: [
      { id: 1, value: "GlacierBlue", isChecked: false },
      { id: 2, value: "Basin", isChecked: false },
       { id: 3, value: "DischargeOutlet", isChecked: false },
      { id: 4, value: "River", isChecked: false },
    ],

  })
  this.getRiverStats()
 //console.log("collapsed in compare",menus.mapSideBar.id)
  let tabs = this.state.tabs;
    let newtabs = tabs.map((tab, index) => {
      if (tab.id === 1 || tab.id === 2) {  /* This 1 and 2 depicts the dropdowns which will get closed when comparsion dropdown is open*/
        if (tab.active === true) {
          tab.active = false;
        } 
      } 
    });
}

handleSnowProductChange=(e)=>{
  let snowproductselected=e.target.value;
  let string = e.target.value.toLowerCase().split(" ").join("-")
 //console.log("snowproooooooooo",snowproductselected)
  if(snowproductselected!=="#")
  {
      this.setState({
          snowproductselected:snowproductselected,
          selectedMainMenu:snowproductselected,
          compareLeftDate: null,
          compareRightDate: null,
          compareLeftLayer: null,
          compareRightLayer: null,
          buttonColor:"black",
      })
      if (snowproductselected === "Snowmelt Rate Forecast") {
            string = "forecast"; // Set 'string' to 'nhp_forecast' for Snowmelt Rate Forecast
        }

        if (snowproductselected === "Daily Snowmelt Rate"){
          string = "actual";
        }
      this.handleSwipeUploadLeft()
      this.getAvailableDates_url(string); 
  }
    };

//YOU CREATED FOR OVERLAY CHECKBOXES and for COMPARE TOOL- YOU USED COLLAPSED3 BECAUSE YOUR COMPARISON TOOL DROPDOWN POSITION IS 3 AND YOU WANT THIS FEATURE TO OPEN WHEN THAT IS SELECTED======

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.date !== prevState.date ||
      this.state.selectedMenu !== prevState.selectedMenu
    ) {
     //console.log(this.state.selectedMenu);
      this.setSelectedLayer(this.state.selectedMenu);
    }
    if (this.state.selectedMenu !== prevState.selectedMenu) {
    }
  }
  handleDialogClose = () => {
          this.setState({
            technicalnoteenable: false,
          });
        };
  handleDialogDClose = () => {
          this.setState({
            disclaimerenable: false,
          });
        };
  handleTechnicalNote = () => {
        this.setState({
          technicalnoteenable: true,
          disclaimerenable: false,
          visibleGraphPanel: false,
          visible:window.innerWidth>1000?true:false,
        });
      };
  handleDisclaimer = () => {
        this.setState({
          technicalnoteenable: false,
          disclaimerenable: true,
          visible:window.innerWidth>1000?true:false,
        });
      };
  toggle = () => {
        this.setState({
          modal: !this.state.modal,
        });
      };
 modeChange=()=>{
      this.setState({
        inlinemode:true
      })
    }
  render() {
    let productList;
   //console.log("this.state.productselectedddddddddddddddddddd",this.state.snowproductselected, this.state.selectedMenu)
    const enabledDates = this.state.availableDates.map((momentDate) => momentDate.toDate());

   //console.log("whynotcominggggg", this.state.availableDates)
    const { selectedMonthStart,selectedMonthEnd,compareLeftDate,compareRightDate,compareRightWorkspace } = this.state;
   //console.log("start and end dates----------------",this.state.startdate,this.state.enddate,this.props.long,this.props.lat,this.state.date_snow)
   //console.log("map in resultttttt",this.state.compareLeftDate,this.state.compareRightDate, this.state.compareRightWorkspace)
   //console.log(this.state.x, this.state.y);
   //console.log("magiiiiiiiiiiiiiiiiii",this.state.tabs)
    let params = new URLSearchParams(this.props.location.search);
    let basinOptions = [],
      subbasinOptions = [];
   //console.log(this.state.visibleGraphPanel);
    let menuList = this.state.tabs.map((child) => {
     //console.log("nox",child.name);
     //console.log("show all displayyyyynames",this.state.tabs)
      if (this.state.tabs) {
        productList = this.state.tabs.map((product) => {
          return <option value={(product.name).split("-")[0]}>{product.displayname}</option>;
        });
      }
   
   
      return (
        <div style={{ padding: "0px"}} key={child.id}>
          <TreeNode
            data={child}
            id={child.id}
            active={child.active}
            inlinemode={this.state.inlinemode}
            modeChange={this.modeChange}
            handleTabClick={this.handleTabClick}
            setSelectedMenu={this.setSelectedMenu}
            setSelectedLayer={this.setSelectedLayer}
            margin={0}
            selectedLayerLink={params.get("selected")}
            toggleSelectedNodeStatus={this.toggleSelectedNodeStatus}
            selectedNodeStaus={this.state.selectedNodeStaus}
            enableDatePicker={this.enableDatePicker}
            enableSlider={this.enableSlider}
            enableForecast={this.enableForecast}
            color={colors["sidebar-main-menu"]}
            setDefaultInfo={this.setDefaultInfo}
            setDate={this.setDate}
            date={this.state.date}
            availableDates={this.state.availableDates}
            handleDateChange={this.handleDateChange}
            riversystem={this.state.riversystem}
            river_basins={this.state.river_basins}
            activeIndex={this.state.activeIndex}
            handleStartDateChange={this.handleStartDateChange}
            handleEndDateChange={this.handleEndDateChange}
            changeRiverBasin={this.changeRiverBasin}
            changeRiverName={this.changeRiverName}
            handleClick_Stats={this.handleClick_Stats}
            startdate={this.state.startdate}
            enddate={this.state.enddate}
          />
        </div>
      );
    });

    if (this.state.basins) {
      this.state.basins.map((result, k) => {
        basinOptions.push({
          key: k,
          name: result.basin,
          value: result.basin,
        });
        return true;
      });
    }
    if (this.state.subbasins) {
      this.state.subbasins.map((result, k) => {
        subbasinOptions.push({
          key: k,
          name: result.subbasin,
          value: result.subbasin,
        });
        return true;
      });
    }

    return (
      <div
        style={{ backgroundColor: "#ffffff", height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
       <AboutModal
            modal={this.props.snowmodal}
            toggle={this.props.toggle}
            title={pagecontent.title}
            bodycontent={pagecontent.bodycontent}
            link={pagecontent.link}
          />
        {/* <Sidebar.Pushable  style={{marginTop:"0px", backgroundColor:colors.background, border:"0px",transfrom:"0px",height:  this.state.selectedMenu==='Daily Snow Cover'?"70%":"100%"}}> */}
        <Sidebar.Pushable
          style={{
            marginTop: "0px",
            backgroundColor: colors.background,
            border: "0px",
            transfrom: "0px",
            height: "100%",
          }}
        >
          <Sidebar
            as={Menu}
            animation="push"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.state.visible}
            style={{
              backgroundColor: colors.background,
              textAlign: "right",
              width: "260px",
              padding: "0px",
              border: "0px",
              margin: "0px",
            }}
          >
            {menuList}
{/*===========================================CREATED FOR SWIPE FEATURE=====================COLLAPSED STARTS HERE============================================================== */}
<div className="modalwindow">
  <div
    as="div"
    onClick={this.SwipeTool}
    className="modalheader"
    style={{ textAlign: "left"}}
    //title="To Continue Analysis, Select a Product for Left Panel and Right Panel"
    title=" Select Products for comparing corresponding products on two different dates. 
    Move the Slider displayed on Map for Comparison. 
    Use Layers Panel on Right-side to change background basemap and add Overlay Layers."
  >

    <div style={{ display: "flex" }}>
      <div style={{ width: "80%" }}> Comparison Slider</div>
      <div style={{ textAlign: "right", width: "20%" }}>
        {this.state.collapsed3 ? (
          <FontAwesomeIcon icon="angle-down" />
        ) : (
          <FontAwesomeIcon icon="angle-right" />
        )}
      </div>
    </div>
  </div>


  {this.state.collapsed3 ? (
    
    <>
      <div
        style={{
          background: colors["final_side_sub"],
          padding: "0px",
          textAlign: "-webkit-center",
        }}
      >
        {/* <div style={{ textAlign: "left", padding: "5px", fontWeight: "bold", marginLeft: "10px" }}>Products</div> */}
        <div
          style={{
            background: colors["final_side_sub"],
            padding: "10px 0px 0px 10px",
           
            textAlign: "left",
          }}
        >
          <label>
            <input
              type="radio"
              name="productR"
              value="Daily Snow Cover"
              checked={this.state.snowproductselected === "Daily Snow Cover"}
              onChange={this.handleSnowProductChange}
            />
            Daily Snow Cover
          </label>
          {/* <br />
          <label>
            <input
              type="radio"
              name="productR"
              value="Snow Cover Fraction"
              checked={this.state.snowproductselected === "Snow Cover Fraction"}
              onChange={this.handleSnowProductChange}
            />
            Snow Cover Fraction
          </label>
          <br />
          <label>
            <input
              type="radio"
              name="productR"
              value="Snowmelt Rate Forecast"
              checked={this.state.snowproductselected === "Snowmelt Rate Forecast"}
              onChange={this.handleSnowProductChange}
            />
            Snowmelt Rate Forecast (3days)
          </label>
          <br /> */}
          <label>
            <input
              type="radio"
              name="productR"
              value="Daily Snowmelt Rate"
              checked={this.state.snowproductselected === "Daily Snowmelt Rate"}
              onChange={this.handleSnowProductChange}
            />
            Daily Snowmelt Rate (Potential)
          </label>
        </div>
      </div>
      <div style={{ display: "flex" }}>
  <div style={{ flex: 1, marginRight: "5px"}}>
    <div style={{ textAlign: "left", padding: "10px", fontWeight: "bold",marginLeft:"-10px" }}>
      {this.state.snowproductselected === "Snowmelt Rate Forecast" ? "Left Forecast Date" : "Left Panel Date"}
    </div>
    <div
      style={{
        background: colors["final_side_sub"],
        padding: "0px",
        textAlign: "-webkit-center",
      }}
    ></div>
    <div className="date-picker-container">
      <DatePicker
        showIcon
        toggleCalendarOnIconClick

        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 48 48"
          >
            <mask id="ipSApplication0">
              <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                <path
                  fill="#fff"
                  d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                ></path>
              </g>
            </mask>
            <path
              fill="currentColor"
              d="M0 0h48v48H0z"
              mask="url(#ipSApplication0)"
            ></path>
          </svg>
        }
        selected={compareLeftDate}
        onChange={this.handleSwipeLeftDateChange}
        dateFormat="dd/MM/yyyy"
        highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
        filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
        dayClassName={(date) => {
          const isEnabled = enabledDates.some(
            (enabledDate) => enabledDate.toDateString() === date.toDateString()
          );
          return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
        }}
        scrollableYearDropdown
        showMonthDropdown

      yearDropdownItemNumber={20}        
        closeOnSelect
        shouldCloseOnSelect={true}
        showYearDropdown
        
        className="custom-date-picker"
        placeholderText="Select Date"
        minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
      />
          </div>
          {this.state.compareLeftDate !== null && (
            <div style={{
              background: colors["final_side_sub"],
              padding: "10px 70px 0px 0px",
              marginLeft: "40px",
              textAlign: "-webkit-center",
              color: "red",
            }}>
            </div>
          )}
        </div>
        <div style={{ flex: 1,  marginLeft: "-115px"}}>
          <div style={{ textAlign: "left", padding: "10px", fontWeight: "bold", marginLeft:"-10px" }}>
          {this.state.snowproductselected === "Snowmelt Rate Forecast" ? "Right Forecast Date" : "Right Panel Date"}</div>
          <div
            style={{
              background: colors["final_side_sub"],
              padding: "0px",
              textAlign: "-webkit-center",
            }}
          ></div>
          <div>
            <DatePicker
             showIcon
             icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 48 48"
              >
                <mask id="ipSApplication0">
                  <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
                    <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
                    <path
                      fill="#fff"
                      d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    ></path>
                  </g>
                </mask>
                <path
                  fill="currentColor"
                  d="M0 0h48v48H0z"
                  mask="url(#ipSApplication0)"
                ></path>
              </svg>
            }
              selected={compareRightDate}
              onChange={this.handleSwipeRightDateChange}
              dateFormat="dd/MM/yyyy"
              highlightDates={enabledDates.map(date => moment(date, 'DD-MM-YYYY').toDate())}
              filterDate={(date) => enabledDates.some((enabledDate) => enabledDate.toDateString() === date.toDateString())}
              dayClassName={(date) => {
                const isEnabled = enabledDates.some(
                  (enabledDate) => enabledDate.toDateString() === date.toDateString()
                );
                return isEnabled ? 'highlighted-day' : ''; // Add custom class to enabled dates
              }}
            yearDropdownItemNumber={20}
              closeOnSelect
              shouldCloseOnSelect={true}
              showYearDropdown
              scrollableYearDropdown
              showMonthDropdown

          
              className="custom-date-picker"
           
              placeholderText="Select Date"
              minDate={new Date(Math.min(...enabledDates.map((d) => d.getTime())))} // Set the minimum date
        maxDate={new Date(Math.max(...enabledDates.map((d) => d.getTime())))} // Set the maximum date
            />
            
          </div>
          {this.state.compareRightDate !== null && (
            <div style={{
              background: colors["final_side_sub"],
              padding: "10px 70px 0px 0px",
              textAlign: "-webkit-center",
              color: "red"
            }}>
            </div>
          )}
        </div>
      </div>
    </>
  ) : null}
</div>


                {/* floating bulletin
                 <div className="YourExistingComponent">
                <h1>Welcome to Your Existing Component</h1>
                <FloatingBulletin /> </div> */}
           
        
{/*=======================================================================Trial version==========================================================================*/}
{/* 
<div className="overlaymodalwindow">
  <div className="overlay" style={{ textAlign: "left" }} onClick={this.toggleOverlayTab}>
    <div style={{ display: "flex" }}>
      <div style={{ width: "80%" }}>Overlay</div>
      <div style={{ textAlign: "right", width: "20%" }}>
        {this.state.overlayTabOpen ? (
          <FontAwesomeIcon icon="angle-down" />
        ) : (
          <FontAwesomeIcon icon="angle-right" />
        )}
      </div>
    </div>
  </div>
  {this.state.overlayTabOpen && (
    <div className="modalbox" style={{ textAlign: "left", margin: "0px", padding: "0px" }}>
      <ul style={{ padding: "0px", margin: "0px" }}>
        {this.state.basinoverlays.map((overlay) => (
          <CheckBoxSnow
            key={overlay.id}
            handleCheckChieldElement={this.handleCheckChieldElement}
            {...overlay}
          />
        ))}
      </ul>
    </div>
  )}
</div> */}

                  <div className="modalwindow_1"
                  >
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
            
              >
                Information
              </div>

              <div className="modalbox">
                {ReactHTMLParser(this.state.information)}

                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleTechnicalNote}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleDisclaimer}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>
          </Sidebar>

          <Sidebar.Pusher dimmed={false} style={{ height: "100%" }}>
            <div
              color="violet"
              style={{
                height: "100%",
                padding: "0px",
                border: "0px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <MapView
              chartData={this.state.chartData}
              baseLayers={this.state.baseLayers}
              displayBaseLayers={this.displayBaseLayers}
              handleAnimationChange={this.handleAnimationChange}
              startdate={this.state.startdate}
              enddate={this.state.enddate}
              lat={this.props.lat}
              long={this.props.long}
              popup={this.state.popup}
              addPopup={this.addPopup}
              DischargePoint={this.state.DischargePoint}
              riverselected={this.state.riverselected}
              india_states_boundary={this.state.india_states_boundary}
                legend_array_overlay={this.state.legend_array_overlay}
                basinoverlays={this.state.basinoverlays}
                handleSwipeChange={this.handleSwipeChange}
                swipevalue={this.state.swipevalue}
                arraycheck={this.state.arraycheck}
                date_snow={this.state.date_snow}
                toggleSnowCover={this.toggleSnowCover}
                tableenable={this.state.tableenable}
                graphenable={this.state.graphenable}
                legend={this.state.legend}
                toggleTableData={this.toggleTableData}
                visibleTableData={this.state.visibleTableData}
                toggleVisibleGraphPanel_pie={this.toggleVisibleGraphPanel_pie}
                activeIndex={this.state.activeIndex}
                daily_stats={this.state.daily_stats}
                tabledata={this.state.tabledata}
                setLatLng={this.setLatLng}
                latlng={this.state.latlng}
                displayLegend={this.displayLegend}
                legendVisible={this.state.legendVisible}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                pointInfo={this.state.pointInfo}
                setLegend={this.setLegend}
                selectedLayer={this.state.selectedLayer}
                visibleLeft={this.state.visible}
                visibleGraphPanel={this.state.visibleGraphPanel}
                visibleGraphPanel_pie={this.state.visibleGraphPanel_pie}
                handleCheckChieldElement={this.handleCheckChieldElement}
                
                
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                visibleDivPanel={this.state.visibleDivPanel}
                toggleDivPanel={this.toggleDivPanel}
                getFeatureInfo={this.getFeatureInfo}
                setStateInfo={this.setStateInfo}
                forecast={this.state.forecast}
                activeDate={
                  moment.isMoment(this.state.date)
                    ? this.state.date.format("DD MMMM YYYY")
                    : moment(this.state.date, "DD-MM-YYYY").format(
                        "DD MMMM YYYY"
                      )
                }
                forecastdate={this.state.forecastdate}
                setDate={this.setDate}
                makeChartDataNDays={this.makeChartDataNDays}
                makeChartDataAvailableDaysWithDateCats={
                  this.makeChartDataAvailableDaysWithDateCats
                }
           
                onClickDetails={{ ...this.state.onClickDetails }}
                setOnClickDetails={this.setOnClickDetails}
                slider={this.state.sliderEnabled}
                information={this.state.information}
                stateInfo={this.state.stateInfo ? this.state.stateInfo : null}
                sliderOptions={{
                  onClickSlideLeft: this.onClickSlideLeft,
                  onClickSlideRight: this.onClickSlideRight,
                  onSlide: this.onSlide,
                  slideTracker: this.state.slideTracker,
                  max: this.state.availableDates.length - 1,
                  date: moment(
                    this.state.availableDates[this.state.slideTracker],
                    "YYYYMMDD"
                  ).format("D MMM YYYY"),
                }}
                himalayan_boundary={this.state.himalayan_boundary}
                geojsonadd={this.state.basininfo}
                river_boundary={this.state.river_boundary}

                visibleGraphPanel1={this.state.visibleGraphPanel1}
                collapsed3={this.state.collapsed3}
                collapsed2={this.state.collapsed2}
                snowproductselected={this.state.snowproductselected}
                
                compareLeftDate={this.state.compareLeftDate}
                compareLeftWorkspace={this.state.compareLeftWorkspace}
                compareRightDate={this.state.compareRightDate}
              
                compareRightWorkspace={this.state.compareRightWorkspace}
                compareLeftLayer={this.state.compareLeftLayer}
                compareRightLayer={this.state.compareRightLayer}

              />
            </div>

            {this.state.technicalnoteenable || this.state.disclaimerenable ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.technicalnoteenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogClose}
                      ></div>
                      Technical Note
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >    <div class="dialog_content">
                  <p style={{textAlign:"justify"}}>
              
Under National Hydrology Project (NHP), one of the activities taken up is development of spatial snowmelt runoff product in catchment areas of Indian River basins. Energy balance approach is used to compute snowmelt rate on daily basis during snowmelt season of April to June months every year. Suomi-NPP and INSAT satellite derived products such as snow cover, snow albedo and snow surface temperature, cloud mask and other atmospheric constituents (Aerosol Optical Depth, Ozone, and Water Vapour) are used for estimating the snowmelt rate. The snowmelt rate is then translated into snowmelt runoff for selected few river outlets. Using Global Ensemble Forecast System (GEFS)/other rainfall and temperature forecast data as in input into the model, snowmelt rate and runoff will be forecasted for next 3 days (T+3) on daily basis during the snowmelt season of every year.   The snow cover extent is generated using Suomi-NPP VIIRS data on daily basis throughout the year from 2015 onwards. 
 </p>
                  <p> <span style={{color:"blue"}}>Input Datasets Used:</span></p>
                  <p> 
                  Suomi-NPP Satellite Products: Suomi-NPP satellite has on board Visible Infrared Imaging Radiometer Suite (VIIRS) sensor using which snow cover parameters such as snow cover area, snow albedo and snow surface temperature are generated on daily basis. These products are generated at 1km spatial resolution. 
                  </p>
                  <p>

INSAT Satellite Products: INSAT-3D/3DR satellite has on board Imaging  sensor and sounder using which cloud mask and atmospheric constituents are generated on daily basis at different spatial and temporal resolutions. Imager products such as Cloud mask and Aerosol Optical Depth (AOD) are available at half hourly interval in 4 km and 11 km spatial resolution respectively. Sounder product information on Water Vapour and Ozone are available at half hourly interval in 11 km spatial resolution (https://www.mosdac.gov.in/).</p>

 <p style={{textAlign:"justify"}}>
 Land Use and Cover Map: Resourcesat-2 AWiFS satellite data was used in generating land use land cover at 56 m spatial resolution containing three land cover classes namely ever green forest, deciduous forest and open areas.</p>

 <p style={{textAlign:"justify"}}>
 SRTM DEM: SRTM DEM of 90m spatial resolution was used in estimating the daily incoming solar radiation based on Julian day, elevation, slope and aspect without considering atmospheric effects (constituents and clouds) during snowmelt seasonal months of April to June (https://srtm.csi.cgiar.org/).
 </p>

 <p style={{textAlign:"justify"}}>
 Soil Map: Soil map generated by National Bureau of Soil Survey and Land Use Planning (NBSS&LUP) 1:50,000 was used to deriving soil textural information. (https://www.nbsslup.in/).
 </p>
<p style={{textAlign:"justify"}}>
Glacier Map: Glaciers outlines generated by International Centre for Integrated Mountain Development (ICIMOD), Randolph Glacier Inventory (RGI) and Global Land Ice Measurements from Space (GLIMS) are combined to prepare glacier raster map for Himalayas.
</p> <p style={{textAlign:"justify"}}>
Meteorological Datasets: Global Ensemble Forecast System (GEFS) /any other suitable gridded daily Temperature forecast data (0.47 degree) for T+3 days are used for generating daily spatial snowmelt rate forecast (https://www.ncdc.noaa.gov/data-access/model-data/model-datasets/global-ensemble-forecast-system-gefs).


</p>
<p><span style={{color:"blue"}}>Model Calibration and Validation: </span></p>
<p style={{textAlign:"justify"}}>
The model estimated snowmelt runoff will be calibrated and validated for selected river outlet locations in Himalayas.   </p>
<p style={{textAlign:"justify"}}>About Products:</p>
<p style={{textAlign:"justify"}}>
Snow Cover Area: Snow cover area is generated from Suomi-NPP VIIRS satellite data on daily basis throughout the year from 2015 onwards.  Normalised Difference Snow Index (NDSI) and temperature based algorithm is used for generating snow cover at 1 km spatial resolution.The product contains 2 classes (1-snow and 2-cloud).</p>

<p style={{textAlign:"justify"}}>
Snowmelt Rate:Snowmelt rate forecast is computed for three successive days (T+1, T+2, T+3, where T = Current Day) using open source weather forecast data. Snowmelt rate forecast indicates the potential snowmelt rate (mm/day) at each grid.
</p>
<p style={{textAlign:"justify"}}>
<span style={{color:"blue"}}>Limitation in the current modeling framework:</span>
<ul><li>
Model computes the snowmelt rate based on net radiation energy flux and assumes sensible heat and latent heat fluxes are a proportion of net radiation. 
</li>
<li>	Model computes the snowmelt rate forecasts assuming all other inputs to be same for T+3 days except temperature forecast. 
</li>
<li>	Model computed snowmelt runoff forecast at a particular river outlet is assumed as the sum of potential snowmelt runoff from all the pixels covering the basin in a day.</li>
</ul>
</p>
<p style={{textAlign:"justify"}}>
<span style={{color:"blue"}}>Utility of Product:</span>
<p style={{textAlign:"justify"}}>
Snow cover area is useful in monitoring the spatial and temporal variations of snow cover dynamics at basin/subbasin scales. It is also an Essential Climate Variable (ECV) and helpful as an input to climate change modelling studies. 


</p><p style={{textAlign:"justify"}}>
Snowmelt runoff is highly critical in planning the reservoirs operations in short-term mode for multiple purposes like drinking water, irrigations hydro-power generation particularly during the summer months. 
<br/><br/>
</p>
</p>
                    </div>
                    </div>
                  </div>
                ) : this.state.disclaimerenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogDClose}
                      ></div>
                      Disclaimer
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    > 
                    <div class="dialog_content">
                    <p style={{textAlign:"justify"}}>
                    The spatial snowmelt rate products and runoff hosted are experimental in nature and requires validation with field data. NRSC does not guarantee the accuracy of information provided and accepts no responsibility or liability for any consequences arising from the use of such data. NRSC uses several open data resources to derive and publishing snowmelt rate products through this website. Neither NRSC nor any other party involved in creating, producing or delivering the product through this website shall be liable for any direct, incidental, consequential, indirect or punitive damages arising out of Users' access to, or use of, the website and the products. User feedback on any errors or inaccuracies will be highly appreciated.
                  </p>
                    <br/>
                    </div>  

                    </div>
                  </div>
                ) : (
                  <div className="sweet-loading">
                    <FadeLoader
                      sizeUnit={"px"}
                      color={"#123abc"}
                      loading={this.state.chartloading}
                    />
                  </div>
                )}
              </Rnd>
            ) : null}

            {this.state.visibleGraphPanel ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState(
                    {
                      width: ref.offsetWidth,
                      height: ref.offsetHeight,
                      ...position,
                    },
                   
                  );
                }}
                bounds="parent"
              >
                {this.state.chartData !== null ? (
                  <Chart  width={this.state.width} height={this.state.height} 
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                    charttitle={this.state.selectedMenu}
                  />
                ) : (
                  <div className="sweet-loading">
                    <FadeLoader
                      sizeUnit={"px"}
                      color={"#123abc"}
                      loading={this.state.chartloading}
                    />
                  </div>
                )}
              </Rnd>
            ) : null}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default MapContainer;